import logger from '../utils/logger';
import React, { createContext, useContext, useState, useEffect } from 'react';

const defaultSettings = {
  theme: 'dark',
  fontSize: 'medium',
  soundEnabled: true,
  volume: 100,
  notificationTone: 'classic',
  repeatNotifications: false,
  repeatInterval: 3,
};

const BaristaSettingsContext = createContext(undefined);

export const useBaristaSettings = () => {
  const context = useContext(BaristaSettingsContext);
  if (context === undefined) {
    throw new Error('useBaristaSettings must be used within a BaristaSettingsProvider');
  }
  return context;
};

export const BaristaSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);

  useEffect(() => {
    const storedSettings = localStorage.getItem('baristaSettings');
  logger.debug('Loading settings from localStorage:', storedSettings);
    if (storedSettings) {
      try {
        const parsedSettings = JSON.parse(storedSettings);
        const mergedSettings = { ...defaultSettings, ...parsedSettings };
  logger.debug('Merged settings:', mergedSettings);
        setSettings(mergedSettings);
      } catch (error) {
  logger.error('Failed to parse stored settings:', error);
      }
    } else {
  logger.debug('No stored settings found, using defaults:', defaultSettings);
    }
  }, []);

  const updateSettings = (newSettings) => {
    const updatedSettings = { ...settings, ...newSettings };
  logger.debug('Updating settings:', { old: settings, new: newSettings, updated: updatedSettings });
    setSettings(updatedSettings);
    localStorage.setItem('baristaSettings', JSON.stringify(updatedSettings));
  };

  const resetSettings = () => {
    setSettings(defaultSettings);
    localStorage.setItem('baristaSettings', JSON.stringify(defaultSettings));
  };

  return (
    <BaristaSettingsContext.Provider value={{ settings, updateSettings, resetSettings }}>
      {children}
    </BaristaSettingsContext.Provider>
  );
};
